// import Vue from "vue"
// import router from "@/router"
import { make } from "vuex-pathify"
// import { Toast } from "buefy/dist/components/toast"
import CustomerProxy from "@/proxies/CustomerProxy"

const state = {
  supportContracts: []
}

const mutations = make.mutations(state)

const actions = {
  async all({ commit }, customerId, params = {}) {
    let response = await new CustomerProxy(params).allSupportContracts(
      customerId
    )
    commit("SET_SUPPORT_CONTRACTS", response)
  },

  async update({ dispatch }, { customerId, data, params = {} }) {
    let response = await new CustomerProxy(params).updateSupportContracts(
      customerId,
      data
    )
    await dispatch("all", customerId)
    return response
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
